import {NgIf} from "@angular/common";
import {AfterViewInit, Component, inject, Input, OnInit} from "@angular/core";
import Modal from 'bootstrap/js/dist/modal';
import {PageConfigurationService} from '../../core/services/page-configuration.service';
import {filter, take} from 'rxjs';
import {GtmService} from '../../google-tag-manager/gtm.service';
import {OpportunityService} from "../../core/services/opportunity.service";

@Component({
    selector: "app-order-summary",
    standalone: true,
    imports: [NgIf],
    templateUrl: "./order-summary.component.html",
    styleUrl: "./order-summary.component.scss",
})
export class OrderSummaryComponent implements OnInit, AfterViewInit {
    @Input() orderType: "original" | "change" = "original";
    @Input() orderId: number | null = null;
    @Input() fileId: string | null = null;
    @Input() alreadyBookedOrder: boolean = false;

    private _opportunityService: OpportunityService = inject(OpportunityService);
    private _pageConfigurationService: PageConfigurationService = inject(PageConfigurationService);
    private _gtmService: GtmService = inject(GtmService);

    isDownloading: boolean = false;
    errorMessage: string = '';
    showError: boolean = false;

    ngOnInit(): void {
        this._pageConfigurationService.pageConfiguration$
            .pipe(
                filter(response => response?.success === true && response.data?.tenantId === 476),
                take(1))
            .subscribe((response) => {
            if (response && response.success && response.data?.tenantId === 476) {
                this._gtmService.push({
                    event: 'conversion',
                    send_to: 'AW-11032246197/etRkCM6Tn6EZELXvyowp',
                    transaction_id: ''
                });
            }
        })
    }

    ngAfterViewInit(): void {
        // Show modal automatically if this is an already booked order
        if (this.alreadyBookedOrder) {
            setTimeout(() => this.showModal(), 100);
        }
    }

    showModal(): void {
        const modalElement = document.querySelector('#orderSummaryModal') as HTMLElement;
        if (modalElement) {
            const modal = new Modal(modalElement);
            modal.show();
        }
    }

    closeModal(): void {
        const modalElement = document.querySelector('#orderSummaryModal') as HTMLElement;
        if (modalElement) {
            const modal = Modal.getInstance(modalElement);
            if (modal) {
                modal.hide();
            }
        }
    }

    get title(): string {
        return this.orderType === "change"
            ? "Change Order Summary"
            : "Order Summary";
    }

    downloadPdf(): void {
        this.isDownloading = true;
        const pdfWindow = window.open('', '_blank');
        this._opportunityService
            .getSummary()
            .subscribe({
                next: (response) => {
                    this.isDownloading = false;
                    if (pdfWindow) {
                        pdfWindow.location.href = response.uri;
                    }
                },
                error: (err) => {
                    this.isDownloading = false;
                    pdfWindow?.close();
                    this.showError = true;
                    this.errorMessage = err.error?.message || 'Failed to download the PDF. Please try again later.';
                    this.showModal();
                }
            });
    }
}
